import { render, staticRenderFns } from "./sales-product-detail.vue?vue&type=template&id=174b5f08&scoped=true"
import script from "./sales-product-detail.vue?vue&type=script&lang=js"
export * from "./sales-product-detail.vue?vue&type=script&lang=js"
import style0 from "./sales-product-detail.vue?vue&type=style&index=0&id=174b5f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174b5f08",
  null
  
)

export default component.exports